<svg
  width="300"
  height="80"
  viewBox="0 0 300 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <path
    fill="currentColor"
    d="M99.6163 15.8836H107.397C113.649 15.8836 117.956 20.2042 117.956 25.7791C117.956 31.4934 113.649 35.8139 107.397 35.8139H99.6163V15.8836ZM103.923 19.786V31.7721H107.258C110.87 31.7721 113.232 29.4028 113.232 25.7791C113.232 22.1554 110.731 19.6467 107.258 19.6467H103.923V19.786Z"
  />
  <path
    fill="currentColor"
    d="M122.96 15.8836H137.965V19.786H127.267V23.8279H136.576V27.7303H127.267V31.9115H138.104V35.8139H122.96V15.8836Z"
  />
  <path
    fill="currentColor"
    d="M142.966 15.8836H147.69L152.97 24.246L158.249 15.8836H162.973V35.8139H158.666V22.8522L153.109 31.354L147.551 22.9916V35.9533H143.244V16.023L142.966 15.8836Z"
  />
  <path
    fill="currentColor"
    d="M167.836 25.925C167.836 20.2107 172.282 15.6114 178.396 15.6114C184.509 15.6114 188.955 20.2107 188.955 25.925C188.955 31.6393 184.509 36.2386 178.396 36.2386C172.282 36.2386 167.836 31.6393 167.836 25.925ZM184.37 25.925C184.37 22.4407 181.869 19.6532 178.396 19.6532C174.922 19.6532 172.421 22.4407 172.421 25.925C172.421 29.4093 174.922 32.1968 178.396 32.1968C181.869 32.1968 184.37 29.4093 184.37 25.925Z"
  />
  <path
    fill="currentColor"
    d="M192.981 25.925C192.981 20.2107 197.288 15.6114 203.402 15.6114C207.153 15.6114 209.376 16.8657 211.182 18.6776L208.403 21.8832C206.875 20.4894 205.347 19.6532 203.263 19.6532C199.928 19.6532 197.427 22.4407 197.427 25.925C197.427 29.4093 199.789 32.1968 203.263 32.1968C205.486 32.1968 206.875 31.3605 208.542 29.8274L211.321 32.6149C209.237 34.8448 207.014 36.2386 203.124 36.2386C197.288 36.2386 192.981 31.6393 192.981 25.925Z"
  />
  <path
    fill="currentColor"
    d="M215.908 15.8836H224.939C227.439 15.8836 229.385 16.5805 230.774 17.9742C231.885 19.0892 232.441 20.6223 232.441 22.5735C232.441 25.9185 230.774 27.8697 228.134 28.8453L232.997 35.9533H227.856L223.549 29.5421H220.076V35.9533H215.769V16.023L215.908 15.8836ZM224.661 25.5003C226.884 25.5003 227.995 24.3853 227.995 22.7129C227.995 20.7617 226.745 19.786 224.522 19.786H220.215V25.5003H224.661Z"
  />
  <path
    fill="currentColor"
    d="M244.389 15.7475H248.418L256.893 35.8172H252.308L250.502 31.3573H242.166L240.36 35.8172H235.914L244.389 15.7475ZM248.974 27.4548L246.334 21.0437L243.694 27.4548H248.974Z"
  />
  <path
    fill="currentColor"
    d="M258.837 25.925C258.837 20.2107 263.144 15.6114 269.257 15.6114C273.009 15.6114 275.232 16.8657 277.038 18.6776L274.259 21.8832C272.731 20.4894 271.203 19.6532 269.118 19.6532C265.784 19.6532 263.283 22.4407 263.283 25.925C263.283 29.4093 265.645 32.1968 269.118 32.1968C271.341 32.1968 272.731 31.3605 274.398 29.8274L277.177 32.6149C275.093 34.8448 272.87 36.2386 268.98 36.2386C263.144 36.2386 258.837 31.6393 258.837 25.925Z"
  />
  <path
    fill="currentColor"
    d="M287.044 28.009L279.403 15.8836H284.543L289.267 23.8279L294.13 15.8836H299.132L291.49 27.8697V35.8139H287.183V28.009H287.044Z"
  />
  <path
    fill="currentColor"
    d="M99.6163 43.3499H114.76V47.3917H104.062V51.5729H113.51V55.6147H104.062V63.2802H99.7553V43.3499H99.6163Z"
  />
  <path
    fill="currentColor"
    d="M118.513 53.3776C118.513 47.6633 122.959 43.064 129.072 43.064C135.186 43.064 139.632 47.6633 139.632 53.3776C139.632 59.0919 135.186 63.6912 129.072 63.6912C122.959 63.6912 118.513 59.0919 118.513 53.3776ZM135.047 53.3776C135.047 49.8933 132.546 47.1058 129.072 47.1058C125.599 47.1058 123.098 49.8933 123.098 53.3776C123.098 56.8619 125.599 59.6494 129.072 59.6494C132.546 59.6494 135.047 56.8619 135.047 53.3776Z"
  />
  <path
    fill="currentColor"
    d="M144.492 43.3499H153.523C156.024 43.3499 157.969 44.0467 159.359 45.4404C160.47 46.5554 161.026 48.0885 161.026 50.0397C161.026 53.3847 159.359 55.3359 156.719 56.3115L161.582 63.4195H156.441L152.134 57.0084H148.661V63.4195H144.354V43.4892L144.492 43.3499ZM153.245 52.9666C155.468 52.9666 156.58 51.8516 156.58 50.1791C156.58 48.2279 155.33 47.2523 153.107 47.2523H148.799V52.9666H153.245Z"
  />
  <path
    fill="currentColor"
    d="M165.75 54.6287V43.2001H170.057V54.4893C170.057 57.8343 171.585 59.3674 174.364 59.3674C177.143 59.3674 178.671 57.8343 178.671 54.6287V43.2001H182.978V54.4893C182.978 60.4824 179.644 63.5486 174.225 63.5486C168.807 63.5486 165.611 60.6217 165.611 54.6287H165.75Z"
  />
  <path
    fill="currentColor"
    d="M188.677 43.3499H193.401L198.68 51.7122L203.96 43.3499H208.684V63.2802H204.377V50.3185L198.819 58.8202L193.262 50.4579V63.4195H188.955V43.4892L188.677 43.3499Z"
  />
  <path
    fill="currentColor"
    d="M0.695312 47.6655C1.25106 50.4529 2.08468 53.101 3.19617 55.7491C27.7879 46.5505 52.7965 45.2961 78.2219 51.0104C78.4998 49.8955 78.7777 48.7805 79.0555 47.6655C52.9355 39.8606 26.8154 39.8606 0.834249 47.6655H0.695312Z"
  />
  <path
    fill="currentColor"
    d="M6.66858 62.1652C8.75263 65.2314 11.2535 68.0188 14.0322 70.3882C34.5948 60.4927 55.4353 57.1477 75.1643 58.4021C75.859 57.0084 76.5537 55.6146 76.9705 54.2209C52.9345 50.1791 28.3427 53.1059 6.66858 62.1652Z"
  />
  <path
    fill="currentColor"
    d="M24.592 76.9273C29.3159 78.8785 34.4565 79.9935 39.8751 79.9935C53.3519 79.9935 65.3004 73.3036 72.5252 62.99C55.5749 63.8262 39.5972 68.4255 24.592 76.9273Z"
  />
  <path
    fill="currentColor"
    d="M17.2281 40C17.2281 27.4564 27.3705 17.2822 39.8748 17.2822C52.3791 17.2822 62.5215 27.4564 62.5215 40V40.2787C68.3568 41.2544 73.9143 42.6481 79.4717 44.3206C79.6106 42.9268 79.7496 41.3937 79.7496 40C79.7496 17.9791 61.9657 0 39.8748 0C17.7839 0 0 17.8397 0 40C0 41.5331 0 42.9268 0.277873 44.3206C5.83534 42.6481 11.3928 41.2544 17.2281 40.2787V40Z"
  />
</svg>
